/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export type EntityType = ENTITY_TYPES | EntityTypeRaw;

// this needs to be dynamic as it changes based on the jobName,
// and tsoa can't parse a template literal type
// so we need to use a string type here
export type EntityTypeRaw = string;

export enum ENTITY_TYPES {
  job = 'job',
  manifest = 'manifest',
  jobExecution = 'jobExecution',
  context = 'context',
}
